import React from 'react';
import { Dialog } from 'primereact/dialog';

function PrimeReactDialog(props) {
  const { children, header, isVisible = false, footer, onHideDialog = () => {}, ...rest } = props || {};
  return (
    <>
      <Dialog header={header} visible={isVisible} style={{ width: '40vw' }} footer={footer} onHide={onHideDialog} {...rest}>
        {children}
      </Dialog>
    </>
  );
}

export default PrimeReactDialog;
